import { render, staticRenderFns } from "./SendEmailCode.vue?vue&type=template&id=45099a56&scoped=true"
import script from "./SendEmailCode.vue?vue&type=script&lang=js"
export * from "./SendEmailCode.vue?vue&type=script&lang=js"
import style0 from "./SendEmailCode.vue?vue&type=style&index=0&id=45099a56&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45099a56",
  null
  
)

export default component.exports